module.exports = __webpack_public_path__ + "static/img/5c09eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/tittle.png
// module id = 690
// module chunks = 2